import AnimationSlide from './animations/AnimationSlide';

export default new class Dropdowns {
    init() {
		this.initDropdowns();
	}

    initDropdowns() {
        if(document.querySelectorAll('.js-dropdown__title').length > 0) {
            document.querySelectorAll('.js-dropdown').forEach(jsDropdown => {
                jsDropdown.querySelector('.js-dropdown__title').setAttribute('aria-expanded', false);
                jsDropdown.querySelector('.js-dropdown__content').setAttribute('aria-hidden', true);
                jsDropdown.querySelector('.js-dropdown__content').classList.add('hidden');
            });
            
            document.querySelectorAll('.js-dropdown__title').forEach((dropdown_title) => {
                dropdown_title.addEventListener('click', (event) => {
                    event.preventDefault();
                    
                    const currentDropdownTitle = event.currentTarget;
                    const currentDropdown = currentDropdownTitle.closest('.js-dropdown');

                    if(currentDropdown.classList.contains('open')) {
                        currentDropdown.classList.remove('open');
                        currentDropdownTitle.setAttribute('aria-expanded', false);
                        currentDropdown.querySelector('.js-dropdown__content').setAttribute('aria-hidden', true);
                        AnimationSlide.slideUp(currentDropdown.querySelector('.js-dropdown__content'));
                    } else {
                        currentDropdown.classList.add('open');
                        currentDropdownTitle.setAttribute('aria-expanded', true);
                        currentDropdown.querySelector('.js-dropdown__content').setAttribute('aria-hidden', false);
                        AnimationSlide.slideDown(currentDropdown.querySelector('.js-dropdown__content'));
                    }
                });
            });
        }
    }
}